import React, { useState, useEffect } from "react";
import axios from "axios";
import { Tooltip, Card, CardContent, Typography, Grid, Box, TextField, MenuItem, Select, InputLabel, FormControl, Slider, IconButton, Button, skeleton, Avatar } from "@mui/material";
import { useNavigate, Link } from "react-router-dom";
import StarIcon from '@mui/icons-material/Star';  // Import Star icon for rating
import FilterListIcon from '@mui/icons-material/FilterList'; // Import the filter icon
import VisibilityIcon from '@mui/icons-material/Visibility';
import avatar from './default-avatar.png'
import ShareIcon from '@mui/icons-material/Share';

import AttachMoneyIcon from '@mui/icons-material/AttachMoney'; // Import the rupee icon
import Header1 from "../Header/Header1";

const API_URL = process.env.REACT_APP_API_URL;



function Requested({ userId, onLogout }) {

  useEffect(() => {
    window.scrollTo(0, 0);  // Scroll to top when this page is loaded
  }, []);


  const [sections, setSections] = useState([]);
  const [subsections, setSubsections] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [languages, setLanguages] = useState([]);
  const [categories, setCategories] = useState([]);
  const [filters, setFilters] = useState({
    rating: 0,
    date: "",
    time: "",
    cost: [0, 500], // Cost range slider
    language: "",
    duration: [0, 120], // Duration range slider in minutes
  });

  const [page, setPage] = useState(1);  // Start with page 1
  const [allFetched, setAllFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [tempDate, setTempDate] = useState(filters.date || "")


  const buildQuery = () => {
    let query = `?user_id=${userId}&page=${page}`;

    if (filters.rating) query += `&rating=${filters.rating}`;
    if (filters.date) query += `&date=${filters.date}`;
    if (filters.time) query += `&time=${filters.time}`;
    if (filters.language) query += `&language=${filters.language}`;
    if (filters.cost) query += `&min_cost=${filters.cost[0]}&max_cost=${filters.cost[1]}`;
    if (filters.duration) query += `&min_duration=${filters.duration[0]}&max_duration=${filters.duration[1]}`;

    return query;
  };


  const fetchData = async () => {
    setLoading(true);

    try {
      const response = await axios.get(`${API_URL}/list_requested_data/${buildQuery()}`);

      if (response.data.length === 0) {
        setAllFetched(true);  // Stop fetching if no new data
      } else {
        setSections((prevSections) => {
          const newSections = response.data.filter(
            (newSection) => !prevSections.some((section) => section.id === newSection.id)
          );
          return [...prevSections, ...newSections];
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setPage(1);
    setAllFetched(false);
    setSections([]);
  }, [filters]);

  // Fetch data on page change or when filters change
  useEffect(() => {
    if (!allFetched) {
      fetchData();
    }
  }, [filters, userId, page]); // Dependencies include page and filters

  // Handle scroll event to detect when the user has scrolled to the bottom
  const handleScroll = () => {
    const scrollPosition = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    if (windowHeight + scrollPosition >= documentHeight - 1 && !loading && !allFetched) {
      setPage((prevPage) => prevPage + 1);  // Increment the page to load next data
    }
  };

  // Add event listener for scroll on component mount and cleanup on unmount
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [loading, allFetched]);

  const extractLanguages = (data) => {
    const allLanguages = new Set();

    data.forEach(item => {
      allLanguages.add(item.name);
    });

    setLanguages([...allLanguages]);
  };


  const navigate = useNavigate();

  const allCards = sections

  const handleFilterChange = (event, filterType) => {
    setFilters({
      ...filters,
      [filterType]: event.target.value,
    });
  };
  const handleSliderChange = (event, newValue, filterType) => {
    if (Array.isArray(newValue)) {
      setFilters({
        ...filters,
        [filterType]: newValue,
      });
    } else {
      setFilters({
        ...filters,
        [filterType]: newValue,
      });
    }
  };

  const filteredCards = allCards.filter(card => {
    const matchesRating = filters.rating ? card.rating >= filters.rating : true;
    const matchesDate = filters.date ? card.date === filters.date : true;
    const matchesTime = filters.time ? card.starttime === filters.time : true;
    const matchesCost = card.price >= filters.cost[0] && card.price <= filters.cost[1];
    const matchesLanguage = filters.language ? card.language === filters.language : true;
    const matchesDuration = true; // Implement duration filter logic here

    return matchesRating && matchesDate && matchesTime && matchesCost && matchesLanguage && matchesDuration;
  });


  const handleSearch = (result) => {
    setSections(result)
  }

  const handleClearFilters = () => {
    setFilters({
      rating: 0,
      date: "",
      time: "",
      cost: [0, 500], // Cost range slider
      language: "",
      duration: [0, 120], // Duration range slider in minutes

    })
    setAllFetched(false);

  }



  return (
    <Box sx={{ padding: "1rem", backgroundColor: "#11111", minHeight: "100vh", mt: -5, ml: { xs: 0, sm: 5 }, }}>
      <Box
        sx={{
          position: 'fixed', // or 'relative' / 'sticky' based on your layout
          top: 0,
          left: 0,
          width: '100%',
          zIndex: 1300, // higher than MUI drawers (default is 1200)
        }}
      >
        <Header1 userId={userId} page_name="request_topic" onSearch={handleSearch} onLogout={onLogout} />
      </Box>

      <Tooltip title="Filter Panel" placement="left">
        <IconButton
          onClick={() => setShowFilters(!showFilters)}
          sx={{
            color: "#ffffff",
            position: "fixed",  // Absolutely position it within the parent box
            top: "70px",            // Add some spacing from the top
            right: "10px",          // Add some spacing from the right edge
            zIndex: 20,
            "&:hover": {
              color: "#1E90FF",  // Icon color on hover
            },
          }}
        >
          <FilterListIcon />
        </IconButton>
      </Tooltip>
      {showFilters && (
        <Box sx={{
          position: "fixed",
          top: "60px",
          right: "0",
          width: "300px",
          height: "100%",
          backgroundColor: "#000000",
          padding: "1rem",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.4)",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          borderRadius: "8px",
          zIndex: "10"
        }}>

          <FormControl sx={{ width: "100%", marginBottom: "1rem", marginTop: "2rem" }}>
            <InputLabel sx={{ color: "#ffffff", letterSpacing: 2, }}>Rating</InputLabel>
            <Select
              value={filters.rating}
              label="Rating"
              onChange={(e) => handleFilterChange(e, "rating")}
              sx={{
                backgroundColor: "#2222",
                color: "#ffffff",
                letterSpacing: 2,
                "& .MuiInputBase-root": {
                  color: "#ffffff",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#2222",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#1E90FF",
                }
              }}
            >
              {[0, 1, 2, 3, 4, 5].map((rating) => (
                <MenuItem key={rating} value={rating} sx={{ letterSpacing: 2, }}>
                  {rating}+
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Box sx={{ display: 'flex', gap: '1rem', alignItems: 'center', flexWrap: 'wrap' }}>
            <TextField
              type="date"
              value={tempDate}
              onChange={(e) => setTempDate(e.target.value)} // Update temp state only
              sx={{
                backgroundColor: "#2222",
                color: "#ffffff",
                letterSpacing: 2,
                "& .MuiInputBase-root": {
                  color: "#ffffff",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#2222",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#1E90FF",
                },
                marginBottom: "1rem",
              }}
            />

            <Button
              variant="contained"
              onClick={() => handleFilterChange({ target: { value: tempDate } }, "date")}
            >
              Apply
            </Button>

          </Box>
          <Box sx={{ width: "100%", marginBottom: "1rem" }}>
            <Typography gutterBottom sx={{ color: "#ffffff", letterSpacing: 2, }}>Duration</Typography>
            <Slider
              value={filters.duration}
              onChange={(e, newValue) => handleSliderChange(e, newValue, "duration")}
              valueLabelDisplay="auto"
              valueLabelFormat={(value) => `${value} mins`}
              min={0}
              max={120}
              step={10}
              sx={{
                color: "#1E90FF",
                letterSpacing: 2,
                "& .MuiSlider-thumb": {
                  backgroundColor: "#1E90FF",
                },
                "& .MuiSlider-rail": {
                  backgroundColor: "#555555",
                },
                "& .MuiSlider-track": {
                  backgroundColor: "#1E90FF",
                }
              }}
            />
          </Box>
          {/* Cost Filter */}
          <Box sx={{ width: "100%", marginBottom: "1rem" }}>
            <Typography gutterBottom sx={{ color: "#ffffff", letterSpacing: 2, }}>Cost</Typography>
            <Slider
              value={filters.cost}
              onChange={(e, newValue) => handleSliderChange(e, newValue, "cost")}
              valueLabelDisplay="auto"
              valueLabelFormat={(value) => `₹ ${value}`}
              min={0}
              max={500}
              step={10}
              sx={{
                color: "#1E90FF",
                letterSpacing: 2,
                "& .MuiSlider-thumb": {
                  backgroundColor: "#1E90FF",
                },
                "& .MuiSlider-rail": {
                  backgroundColor: "#555555",
                },
                "& .MuiSlider-track": {
                  backgroundColor: "#1E90FF",
                }
              }}
            />
          </Box>

          <Box sx={{}}>
            <Button
              onClick={handleClearFilters}
              variant="outlined"
              sx={{
                width: "100%",
                color: "#1E90FF",
                letterSpacing: 2,
                borderColor: "#1E90FF",
                "&:hover": {
                  backgroundColor: "#1E90FF",
                  color: "#fff"
                }
              }}
            >
              Clear Filters
            </Button>
          </Box>

        </Box>
      )}
      <Box sx={{ marginRight: showFilters ? "75px" : "0", transition: "margin-right 0.3s", }}>
        <Grid
          container
          spacing={2}
          sx={{
            marginTop: showFilters ? "2px" : "0", // Adjust the cards' position when filters are shown
            width: showFilters ? "calc(100% - 200px)" : "100%", // Dynamically adjust width when filter is shown
            marginRight: "auto", // Center the grid container
            justifyContent: "center", // Center the grid content
            display: "flex", // Ensure flexbox layout is used
            flexWrap: "wrap", // Allow wrapping for responsive design
          }}
        >
          {allCards.map((card, cardIndex) => (
            <Grid
              item
              xs={12} // 12 columns on extra small screens (1 card per row)
              sm={showFilters ? 12 : 6}  // 12 columns on small screens when filters are open (1 card per row), else 2 cards per row
              md={showFilters ? 6 : 4}   // 6 columns on medium screens when filters are open (2 cards per row), else 3 cards per row
              lg={showFilters ? 4 : 3}   // 4 columns on large screens when filters are open (3 cards per row), else 4 cards per row
              key={cardIndex}
            >
              <Tooltip title="Click to View" placement="top">
                <Link to={`/request-tab-details/${card.id}/${userId}`} style={{ textDecoration: "none" }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      backgroundColor: "#3333",
                      borderRadius: "15px",
                      overflow: "hidden",
                      boxShadow: "0 8px 20px rgba(0, 0, 0, 0.1)",
                      transition: "transform 0.3s, box-shadow 0.3s",
                      textDecoration: "none",
                      color: "inherit",
                      width: "100%",
                      height: "auto",
                      minWidth: "250px", // Minimum width to prevent shrinking too much
                      borderColor: "#5555",
                      padding: "10px",
                      "&:hover": {
                        transform: "translateY(-5px)",
                        border: "1px solid transparent", // Transparent border for hover effect
                        backgroundClip: "padding-box",
                        borderImage: "linear-gradient(45deg, #00bfff, #ff00ff) 1", // Apply the gradient to the border
                        boxShadow: "0 15px 25px rgba(0, 0, 0, 0.15)",
                      },
                      // Responsive styling
                      "@media (max-width: 1440px)": {
                        minWidth: "280px", // Larger minWidth for medium-large screens
                        padding: "9px", // Slightly adjust padding for large screens
                      },
                      "@media (max-width: 1200px)": {
                        minWidth: "240px", // Reduce minWidth for medium screens
                        padding: "8px", // Adjust padding for medium screens
                      },
                      "@media (max-width: 768px)": {
                        flexDirection: "column", // Stack elements vertically for tablets
                        minWidth: "200px", // Further reduce minWidth for tablets
                        padding: "6px", // Reduce padding on smaller screens
                      },
                      "@media (max-width: 480px)": {
                        padding: "5px", // Further reduce padding on very small screens
                        minWidth: "250px", // Minimum width adjusted for small screens
                      },
                    }}
                  >
                    <Box
                      sx={{
                        padding: "15px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        height: "100%",
                      }}
                    >

                      <Grid container spacing={1} sx={{ justifyContent: "center", alignItems: "center" }}>
                        {/* Teacher Image */}
                        <Grid item xs={3} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                          <Avatar sx={{
                            width: 50,
                            height: 50,
                            // mr: 2,
                          }} src={`${API_URL}${card.image}` || '/default-avatar.png'} alt={card.teacher || 'User'} />





                        </Grid>
                        {/* Teacher Name */}
                        <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: { xs: "0.9rem", sm: "1rem", md: "1.2rem" }, // Responsive font size
                              color: "white",
                              textAlign: "center", // Keeps text centered across all screen sizes
                              marginTop: { xs: "3px", sm: "5px", md: "5px" }, // Adjust top margin for different screen sizes
                              marginBottom: { xs: "3px", sm: "5px", md: "5px" }, // Optional: Adjust bottom margin for consistency
                              paddingX: { xs: "8px", sm: "12px", md: "16px" }, // Horizontal padding for smaller screens
                              width: "100%", // Ensure full width for the container
                              boxSizing: "border-box", // To avoid padding affecting width
                              whiteSpace: "nowrap", // Prevent the text from wrapping
                              overflow: "hidden", // Hide overflowed text
                              textOverflow: "ellipsis", // Show ellipsis when text overflows
                              letterSpacing: 3,
                            }}
                          >
                            {`${(card.teacher + ' ' + card.surname).slice(0, 40)}${(card.teacher + ' ' + card.surname).length > 40 ? '...' : ''}`}
                          </Typography>
                        </Grid>

                        <Typography
                          variant="h6"
                          sx={{
                            fontSize: { xs: "0.9rem", sm: "1.2rem", md: "1rem" }, // Responsive font size for different screen sizes
                            fontWeight: 500,
                            textAlign: "center", // Centers text on all screen sizes
                            color: "white",
                            letterSpacing: 3,
                            mt: { xs: 1, sm: 2, md: 2 }, // Adjust top margin based on screen size
                            mb: { xs: 1, sm: 2, md: 2 }, // Adjust bottom margin for spacing on different screen sizes
                            px: { xs: 1, sm: 2, md: 2 }, // Add some horizontal padding for smaller screens

                          }}
                        >
                          {card.highlightedTopic.length > 100
                            ? `${card.highlightedTopic.slice(0, 100)}...`
                            : card.highlightedTopic}
                        </Typography>


                        <Grid container justifyContent="center" spacing={2}>
                          <Grid item xs={12} sm={10} md={12} lg={10} xl={10}>
                            <Button
                              variant="contained"
                              color="primary"
                              sx={{
                                fontSize: { xs: '0.9rem', sm: '1rem', md: '1rem' }, // Responsive font size
                                padding: { xs: '10px 15px', sm: '12px 20px', md: '14px 25px' }, // Adjust padding based on screen size
                                borderRadius: '8px',
                                boxShadow: 4,
                                backgroundImage: 'linear-gradient(45deg, #2196F3, #1976D2)', // Blue gradient
                                '&:hover': {
                                  backgroundImage: 'linear-gradient(45deg, #1976D2, #2196F3)', // Reversed gradient on hover
                                  boxShadow: 6,
                                  transform: 'scale(1.05)', // Slight scale up on hover for more emphasis
                                },
                                display: 'flex',
                                alignItems: 'center',
                                letterSpacing: 3,
                                justifyContent: 'center',
                                transition: 'all 0.3s ease',
                                width: '100%', // Full width for all screen sizes
                                maxWidth: '300px', // Maximum width to prevent the button from becoming too large
                                margin: '0 auto', // Center the button
                              }}
                            >
                              Accept Now
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>

                </Link>
              </Tooltip>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}
export default Requested;